import React from 'react';

const SvgPw = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="PW_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="PW_svg__b" fill="#fff">
        <use xlinkHref="#PW_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#PW_svg__a" />
      <path fill="#65C6EE" mask="url(#PW_svg__b)" d="M0 0h28v20H0z" />
      <circle fill="#FFE044" mask="url(#PW_svg__b)" cx={12.667} cy={10} r={6} />
    </g>
  </svg>
);

export default SvgPw;
